export const type = 'closeMenuLateral';

const closeMenuLateral = (text) => ({
    type,
    payload: new Date(),
    accion:text
});

export default closeMenuLateral;